/* The icon set, lifted from the artboards.
   All 24×24, stroked at 2.75 — the weight the canvas draws them at, which is
   what keeps them legible at 14px on a phone held at arm's length in the sun. */

interface Props { size?: number; className?: string }

function S({ size = 19, className, children }: Props & { children: React.ReactNode }) {
  return (
    <svg
      width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth="2.75" strokeLinecap="round" strokeLinejoin="round"
      className={className} aria-hidden="true" focusable="false"
    >
      {children}
    </svg>
  );
}

export const IconClock = (p: Props) => <S {...p}><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></S>;
export const IconCalendar = (p: Props) => <S {...p}><rect x="4" y="5" width="16" height="16" rx="4" /><path d="M8 3v4M16 3v4M4 11h16" /></S>;
export const IconPin = (p: Props) => <S {...p}><path d="M12 21s7-6.3 7-11a7 7 0 1 0-14 0c0 4.7 7 11 7 11z" /><circle cx="12" cy="10" r="2.4" /></S>;
export const IconPinSolid = (p: Props) => <S {...p}><path d="M12 21s7-6.3 7-11a7 7 0 1 0-14 0c0 4.7 7 11 7 11z" /></S>;
export const IconImages = (p: Props) => <S {...p}><rect x="4" y="4" width="16" height="16" rx="4" /><circle cx="9.5" cy="9.5" r="1.6" /><path d="M5 17l4.5-4 4 3.2 2.5-2.3L19 17" /></S>;
export const IconCamera = (p: Props) => (
  <S {...p}>
    <path d="M4 8.5A2.5 2.5 0 0 1 6.5 6h1.2l1.2-2h6.2l1.2 2h1.2A2.5 2.5 0 0 1 20 8.5v8A2.5 2.5 0 0 1 17.5 19h-11A2.5 2.5 0 0 1 4 16.5z" />
    <circle cx="12" cy="12.5" r="3.4" />
  </S>
);
export const IconSun = (p: Props) => (
  <S {...p}>
    <circle cx="12" cy="12" r="4.2" />
    <path d="M12 3v2M12 19v2M3 12h2M19 12h2M5.6 5.6l1.4 1.4M17 17l1.4 1.4M18.4 5.6L17 7M7 17l-1.4 1.4" />
  </S>
);
export const IconMoon = (p: Props) => <S {...p}><path d="M20.5 14.3A8.5 8.5 0 0 1 9.7 3.5 8.5 8.5 0 1 0 20.5 14.3z" /></S>;
export const IconBack = (p: Props) => <S {...p}><path d="M15 18l-6-6 6-6" /></S>;
export const IconForward = (p: Props) => <S {...p}><path d="M9 6l6 6-6 6" /></S>;
export const IconExternal = (p: Props) => <S {...p}><path d="M7 17L17 7M9 7h8v8" /></S>;
export const IconShield = (p: Props) => <S {...p}><path d="M12 3l7 3v6c0 4.2-2.9 7.6-7 9-4.1-1.4-7-4.8-7-9V6z" /><path d="M9.2 12.2l2 2 3.6-3.9" /></S>;
export const IconInfo = (p: Props) => <S {...p}><circle cx="12" cy="12" r="9" /><path d="M12 8v.01M12 11v5" /></S>;
export const IconCheck = (p: Props) => <S {...p}><path d="M5 13l4 4 10-10" /></S>;
export const IconClose = (p: Props) => <S {...p}><path d="M6 6l12 12M18 6L6 18" /></S>;
export const IconPlus = (p: Props) => <S {...p}><circle cx="12" cy="12" r="9" /><path d="M12 8v8M8 12h8" /></S>;
export const IconEyeOff = (p: Props) => (
  <S {...p}>
    <path d="M3 3l18 18M10.6 10.7a2 2 0 0 0 2.8 2.8" />
    <path d="M6.8 6.9C4.7 8.3 3 10.4 2 12c1.7 3 5.5 6 10 6 1.6 0 3.1-.4 4.4-1M9.9 6.2A9.6 9.6 0 0 1 12 6c4.5 0 8.3 3 10 6-.6 1-1.5 2.1-2.6 3" />
  </S>
);
export const IconEye = (p: Props) => <S {...p}><path d="M2 12c1.7-3 5.5-6 10-6s8.3 3 10 6c-1.7 3-5.5 6-10 6S3.7 15 2 12z" /><circle cx="12" cy="12" r="2.6" /></S>;
export const IconWifiOff = (p: Props) => (
  <S {...p}><path d="M3 3l18 18" /><path d="M5 12.5a10 10 0 0 1 4-2.4M12 17.5v.01M8.7 14.7a6 6 0 0 1 2.3-1.1" /></S>
);
export const IconLocate = (p: Props) => <S {...p}><circle cx="12" cy="12" r="7" /><path d="M12 2v3M12 19v3M2 12h3M19 12h3" /></S>;
export const IconHeart = (p: Props) => <S {...p}><path d="M12 20.4S4.5 15.6 4.5 10.6A3.9 3.9 0 0 1 12 8.4a3.9 3.9 0 0 1 7.5 2.2c0 5-7.5 9.8-7.5 9.8z" /></S>;
export const IconKey = (p: Props) => (
  <S {...p}><circle cx="15.2" cy="8.8" r="4" /><path d="M12.4 11.6 4 20v1.5h2.4v-1.9h1.9v-1.9h1.9v-1.9" /></S>
);
export const IconUser = (p: Props) => <S {...p}><circle cx="12" cy="8.5" r="3.6" /><path d="M5 20a7 7 0 0 1 14 0" /></S>;

export const IconPlay = ({ size = 16 }: Props) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M7 4l13 8-13 8z" /></svg>
);
export const IconGithub = ({ size = 14 }: Props) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M12 2a10 10 0 0 0-3.2 19.5c.5.1.7-.2.7-.5v-1.8c-2.8.6-3.4-1.3-3.4-1.3-.4-1.1-1.1-1.4-1.1-1.4-.9-.6.1-.6.1-.6 1 .1 1.5 1 1.5 1 .9 1.5 2.3 1.1 2.9.8.1-.7.4-1.1.6-1.4-2.2-.3-4.6-1.1-4.6-5 0-1.1.4-2 1-2.7-.1-.3-.4-1.3.1-2.6 0 0 .8-.3 2.7 1a9.3 9.3 0 0 1 5 0c1.9-1.3 2.7-1 2.7-1 .5 1.3.2 2.3.1 2.6.6.7 1 1.6 1 2.7 0 3.9-2.4 4.7-4.6 5 .4.3.7.9.7 1.9v2.8c0 .3.2.6.7.5A10 10 0 0 0 12 2z" />
  </svg>
);
